import React from 'react';
import { TableFilters, InputContainer, BelongsToFilterSelects } from '../../design-system';
import { extendContainerValidator } from '../../utils';
import { RepairStatus } from '../../types';
import { INPUT_ERRORS } from '../../const';
import { i18n } from '../../i18n';

interface Props {
  number?: string;
  status?: RepairStatus;
  setStates: any;
}

export const Filters: React.FC<Props> = ({ number = '', setStates }: Props) => {
  return (
    <TableFilters>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
      />
      <InputContainer
        label={i18n.t('label.containerNumber')}
        data-size={'medium'}
        defaultValue={number}
        onChange={(e) => {
          const value = e.target.value.toUpperCase();
          setStates('number', value);
        }}
        helperText={
          number.length !== 0 && number.length < 3
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
            : !extendContainerValidator(number)
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
            : ''
        }
        alwaysShowHelperText
      />
      {/* <TableFilterSelect
        label={i18n.t('label.status')}
        options={repairStatusOptions}
        value={status}
        onChange={(e) => {
          setStates('force', {
            status: e.target.value,
          });
        }}
      /> */}
    </TableFilters>
  );
};
